export * from './ArrowDUturnLeftUpIcon';
export * from './ArrowDUturnLeftUpIcon16Light';
export * from './ArrowDUturnLeftUpIcon16Regular';
export * from './ArrowDUturnLeftUpIcon16Solid';
export * from './ArrowDUturnLeftUpIcon20Light';
export * from './ArrowDUturnLeftUpIcon20Regular';
export * from './ArrowDUturnLeftUpIcon20Solid';
export * from './ArrowDUturnLeftUpIcon24Regular';
export * from './ArrowDUturnLeftUpIcon24Solid';
export * from './ArrowDUturnLeftUpIcon32Regular';
export * from './ArrowDUturnLeftUpIcon64Regular';
